import styled from 'styled-components';

export const RateDriverModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const RatingButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 24px;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const RatingButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  min-width: 0;
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #2f3d48;

  svg {
    font-size: 32px;
    color: #666;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  span {
    text-align: center;
    width: 100%;
  }

  &:hover {
    border-color: #ccc;
    background: #f9f9f9;
  }

  &.active {
    border-color: hsl(220, 20%, 20%);
    background-color: hsl(220, 15%, 95%);

    svg {
      color: hsl(220, 20%, 20%);
    }
  }

  @media (max-width: 767px) {
    min-width: 100%;
    padding: 20px 24px;
  }
`;

export const ReasonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
  position: relative;
`;

export const ReasonButton = styled.button`
  padding: 10px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #2f3d48;
  white-space: nowrap;

  &:hover {
    border-color: #ccc;
    background: #f9f9f9;
  }

  &.selected {
    border-color: #ff2d38;
    background: #fff5f5;
    color: #ff2d38;
    font-weight: 500;
  }
`;

export const DetailsSection = styled.div`
  position: relative;
`;
